import React from "react";

import { TextCenter } from "src/common/components/TextAlign";

import dashboardLinksGif from "./dashboard_links.gif";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>
			A verzióban kattinthatóvá tettük a Páciens áttekintő nézetén a
			vizsgálati eredményeket.
		</h1>
		<p>
			Egy vizsgálati eredményre kattintva megjelenik az adott vizsgálat
			űrlapjának utolsó verziója, melyen a ‘Szerkesztés’ gombra kattintva
			szerkeszthetővé válnak az adatok.
		</p>
		<TextCenter>
			<img src={dashboardLinksGif} width="90%" />
		</TextCenter>
	</section>
);
